module.exports = __webpack_public_path__ + "m-wxShareBox-ok-114f2d64.png";